
import Vue, { PropType } from "vue";
import { Alert, AlertStatus, ToiletType } from "@/models";

export default Vue.extend({
  name: "AlertListItem",

  props: {
    alert: Object as PropType<Alert>,
  },

  computed: {
    floorPlanUrl(): string | undefined {
      return this.alert.floorPlanUrl;
    },
    alertTypeText(): string {
      const type = this.alert.alertType;
      if (type === "door-v1") return "ドアセンサ-V1";
      if (type === "door-v2") return "ドアセンサ-V2";
      if (type === "door-r1") return "ドアセンサ-R1";
      if (type === "infrared-v1") return "人感センサ-V1";
      if (type === "infrared-r1") return "人感センサ-R1";
      if (type === "distance") return "距離センサ";
      if (type === "mic") return "MIC";
      if (type === "thermopile") return "サーモセンサー";
      if (type === "low-battery") return "センサ電池";
      if (type === "gw") return "GW";
      return "不明";
    },
    alertTypeClassText(): string {
      switch (this.alert.alertType) {
        case "GW":
          return "red";
        case "MIC":
          return "red";
        case "COUNT":
          return "red";
        case AlertStatus.RESOLVED:
          return "resolved";
        default:
          return "red";
      }
    },

    toiletTypeText(): string {
      switch (this.alert?.kind) {
        case ToiletType.FOR_MAN:
          return "男性トイレ";
        case ToiletType.FOR_WOMAN:
          return "女性トイレ";
        case ToiletType.UNISEX:
          return "共用";
        case ToiletType.MULTI_PURPOSE:
          return "多目的トイレ";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.alert?.status) {
        case "停止":
          return "red";
        case "LOW2":
          return "red";
        case "LOW1":
          return "orange";
        default:
          return "";
      }
    },
    statusText(): string {
      switch (this.alert?.status) {
        case "停止":
          return "停止";
        case "LOW2":
          return "LOW";
        case "LOW1":
          return "LOW";
        default:
          return "";
      }
    },
  },
});
